<template>
	<div>

		<card>
			<h3>Не скрывать эту карточку, здесь Таня и Александр проверяют отправку ссылок для сотрудников в КВК</h3>
			<div class="d-flex wrap align-items-center">
				<base-input
					class="mb-0 mr-2"
					placeholder="Номер телефона +7"							
					v-model="searchKVK"
					autocomplete="off"
					type="text"
				>
				</base-input>

				<button type="button" class="btn my-0 btn-primary btn-simple mr-2" @click="getKVKdata(searchKVK)">Запросить данные</button>
				<button type="button" class="btn my-0 btn-danger btn-simple" @click="searchKVK='';KVKdata=[];">Очистить</button>
			</div>
			<el-table ref="multipleTable" 
			:data="KVKdata" 
			style="width: 100%" 
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			v-if="this.KVKdata.length > 0">	
				<el-table-column
				type="index"
				width="100"
				>
				</el-table-column>

				<el-table-column
				label="first_name"
				min-width="150"
				prop="first_name">
					<template v-slot="scope">
						<span v-if="scope.row.last_name">{{scope.row.last_name}} </span> <span v-if="scope.row.first_name">{{scope.row.first_name}}</span>
					</template>
				</el-table-column>
				<el-table-column
				label="phone"
				min-width="150"
				prop="phone">
				</el-table-column>
				<el-table-column
				label="подключено"
				min-width="80"
				prop="joined">
					<template v-slot="scope">
						<span v-if="scope.row.joined && scope.row.joined!=undefined && (scope.row.joined == 1)">Да</span> 
						<span v-else>Нет</span>
					</template>
				</el-table-column>

				<el-table-column
				label="date_insert"
				min-width="150"
				prop="date_insert">
				</el-table-column>
				<el-table-column
				label="date_join"
				min-width="150"
				prop="date_join">
				</el-table-column>
				<el-table-column
				label="link_send"
				min-width="150"
				prop="link_send">
				</el-table-column>
				<el-table-column
				label="join_link"
				min-width="150"
				prop="join_link">
					<template v-slot="scope">
						<div class="d-flex">
							<div>{{scope.row.join_link}}</div>
							<ReCopyClipboard v-model="scope.row.join_link" v-if="scope.row.join_link"/>
						</div>
					</template>
				</el-table-column>
			</el-table>
			
		</card>

		<!--
		<card>
			<el-tooltip content="Для сравнение с поп-овером" placement="top">
				<base-input
					type="textarea"
					v-model="tooltipvalue"
				></base-input>
			</el-tooltip>
			<el-tooltip content="Для сравнение с поп-овером" placement="top">

			</el-tooltip>
		</card>
		
		
		<card>
			<ReMapAddress />
		</card>

		<card class="d-none">
			<div class="block">
				<span class="demonstration">Smiling rating</span>
				<el-rate
					v-model="rating"
					:icon-classes="['ics-rate-face-1', 'ics-rate-face-2', 'ics-rate-face-3']"
					void-icon-class="ics-rate-face-off"
					:colors="['#99A9BF', '#F7BA2A', '#FF9900']"
					show-text
					:texts="['oops', 'disappointed', 'normal', 'good', 'great']"
				></el-rate>
			</div>
			<div class="block">
				<span class="demonstration">Default rating</span>
				<el-rate 
					v-model="rating2" 
					:colors="['#99A9BF', '#F7BA2A', '#FF9900']"
					show-text
					:texts="['oops', 'disappointed', 'normal', 'good', 'great']"
				></el-rate>
			</div>
		</card>

		
		-->

		<!-- <card>
				<ReSelectScheduleServices />
		</card> -->


<!-- 
		<card v-if="false" title="Тест фильтров объектов для полей и выгрузок">
			  <ReObjFilter v-model="objFilters"/>
			{{ objFilters }}
		</card>

		<card v-if="true" title="Тест редатора выгрузок">
			<ReExportRules v-model="exportRules" :pretty="true"/>
			<pre>{{ exportRules }}</pre>
			<ReCopyClipboard v-model="exportRules"/>
		</card> -->

		<card>
			<div class="form-group col-md-12">
			<p> это компонент BaseDateTimePicker. Я не помню кто его припер</p>
			<p> это компонент BaseDateTimePicker. datetimelocal</p>
			<BaseDateTimePicker 
				type="datetimelocal"
				v-model="datetimelocalvalue"
				label="Дата и время"
				
			/>
			<p> это компонент BaseDateTimePicker. date</p>
			<BaseDateTimePicker 
				type="date"
				v-model="datevalue"
				label="Дата"
				
			/>
			<p> это компонент BaseDateTimePicker. regular</p>
			<BaseDateTimePicker 
				type="regular"
				v-model="regularvalue"
				label="Дата и время"
				
			/>
			</div>
		</card>

		<card>
			<h3>Бахнуть в кафку бланк</h3>
			<button class="btn btn-simple btn-success mx-auto my-0" @click="sendBlank()">sendBlank</button>
			<hr>
			<ReFileUpload 
				v-model="blank_file"
				:type="'file'"
				:formId="'blankUpload'+'_'+Math.random()"
				:bShowTrash="true"
				strFilrPath="/DATA/blanks/file/"
				:uploadApi="blank_uploadApi"
				:delApi="blank_delApi"
				v-on:change="OnUploadFile"
				:bShowDraggable="false"
			/>
		</card>

		<card>
			<ReSelectBlankServices />
		</card>

		<card>
			<ReServiceNoPurpose />
		</card>
		

		<card class="">
			<ReInputRoomSum />
			<ReUsefulSquare />
			<!-- <ReSharePercent /> -->
		</card>
		<!-- <card class="">
			<ReMessengersTemplate />
		</card> -->

		<card class="Instrfortasks">
			<ReFormPrinter 
				:masFormConfig="masAllFormParams" 
				:objSaveApiMethod="currentApiFormMethod"
				:SuccessGo="SuccessGo"/>
		</card>

		<card>
			<ReIconsTemplate />
			
		</card>
		

	</div>
</template>
<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
	import ReFileUpload from 'src/our_components/ReFileUpload.vue';
	// import RePlace from 'src/our_components/RePlace.vue';
	// import ReCellMapEditor from 'src/our_components/ReCellMapEditor.vue';
	// import ReSearchScndObjSmall from 'src/our_modules/SearchSendObjects/ReSearchScndObjSmall.vue';
	// import ReSearchScndFlatBig from 'src/our_components/ReSearchScndFlatBig.vue';
	// import ssoModuleScndFilter from 'src/our_modules/SearchSendObjects/sso_module_scnd_filter.vue';
	// import ReMapAddress from 'src/our_components/ReMapAddress.vue';
	// import ReInputMetroNest from 'src/our_components/ReInputMetroNest.vue';
	import BaseDateTimePicker from 'src/our_components/datetimepickers/BaseDateTimePicker.vue';
	import ReServiceNoPurpose from 'src/our_components/ReServiceNoPurpose.vue';
	// import ReDistrictPicker from 'src/our_components/ReDistrictPicker.vue';
	// import ReMessengersTemplate from 'src/our_components/ReMessengersTemplate.vue';
	import ReInputRoomSum from 'src/our_components/ReInputRoomSum.vue';
	import ReUsefulSquare from 'src/our_components/ReUsefulSquare.vue';
	// import ReSharePercent from 'src/our_components/ReSharePercent.vue';
	// import ReLeadSearchObjCopy from 'src/our_components/ReLeadSearchObjCopy.vue';	
	
	import ReSelectBlankServices from 'src/our_components/ReSelectBlankServices.vue';
	import ReIconsTemplate from 'src/our_components/ReIconsTemplate.vue';


	import { Table, TableColumn } from 'element-ui';
	import { Select, Option, Tooltip, Button, Rate, /*Input,*/} from 'element-ui';
	import Card from '../components/Cards/Card.vue';
	import ReCopyClipboard from "src/our_components/ReCopyClipboard.vue";

	// import ReObjFilter from "src/our_components/ReObjFilter.vue";
	// import ReExportRules from "src/our_components/ReExportRules.vue";

	// import ReSelectScheduleServices from "src/our_components/ReSelectScheduleServices.vue";
	// import ReInputSyntaxHighlight from "src/our_components/ReInputSyntaxHighlight.vue";

	export default {
		name: 'instrfortasks-page',
		components: {
			ReFormPrinter,
			ReFileUpload,
			// RePlace,
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			[Option.name]: Option,
			[Select.name]: Select,
			[Tooltip.name]: Tooltip,	
			[Button.name]: Button,
			//ReSelectCascade,
			// ReCellMapEditor,
			// ReSearchScndObjSmall,
			// ReSearchScndFlatBig,
			// ssoModuleScndFilter,
			// ReMapAddress,
			// ReInputMetroNest,
			[Rate.name]: Rate,
			BaseDateTimePicker,
			// Input,
			ReServiceNoPurpose,
			// ReDistrictPicker,
			// ReMessengersTemplate,
			ReInputRoomSum,
			ReUsefulSquare,
			// ReSharePercent,
			ReSelectBlankServices,
			ReIconsTemplate,
			Card,
			// ReLeadSearchObjCopy,
			// Textarea,
			ReCopyClipboard,
			// ReObjFilter,
			// ReExportRules,		
			// ReSelectScheduleServices,	
			// ReInputSyntaxHighlight,
		},
		data() {
			return {
				blank_file: [],
				//blank_uploadApi: {"apiMethod":"UniUpload","apiParam":{"obj":"FileUpload","flt":{"type":"blanks"}}},
				blank_uploadApi: {"apiMethod":"Created","apiParam":{"obj":"blanks","flt":{"type":"blanks"}}},
				blank_delApi: {"apiMethod":"DEL","apiParam":{"obj":"blanks","flt":{"id":-1}}},
				msg_textTemplate: 'Многа текста Многа текста Многа текста Многа текста Многа текста Многа текста Многа текста Многа текста',
				msg_contacts: [
					{"contact_id":65,"contact_group":"phone","contact_type":"1","contact_value":"+7 921 323-67-00","contact_view":0,"code":32,"contact_src_value":"","concact_phone_INT":"79213236700"},
					{"contact_id":727,"contact_group":"messanger","contact_type":"40","contact_value":"+7 921 323-67-00","contact_view":0,"code":32,"contact_src_value":"","concact_phone_INT":"79213236700"},
					{"contact_id":728,"contact_group":"messanger","contact_type":"41","contact_value":"+7 921 323-67-00","contact_view":0,"code":32,"contact_src_value":"","concact_phone_INT":"79213236700"},
					{"contact_id":1106,"contact_group":"messanger","contact_type":"42","contact_value":"+7 921 323-67-00","contact_view":0,"code":32,"contact_src_value":"","concact_phone_INT":"79213236700"}
				],
				strCatName: '',
				masCat:[],
				polygon:'[]',
				ApiData: {},
				masAllFormParams: this.currentFormConfig(),
				currentApiFormMethod:{apiMethod:'GET',apiParam:{obj:'template' ,flt:{},uData:[]}},				
				masClasses: {
					options: [
						{value: '0',label: 'Бизнес',},
						{value: '1',label: 'Комфорт',},
						{value: '2',label: 'Стандарт',},
					],
				},
				masAdSource: {
					options: [
						{value: '0',label: '1 - avito.ru',},
						{value: '1',label: '2 - irr.ru',},
						{value: '2',label: '3 - realty.yandex.ru',},
						{value: '3',label: '4 - cian.ru',},
						{value: '4',label: '5 - sob.ru',},
						{value: '5',label: '6 - youla.io',},
						{value: '6',label: '10 - moyareklama.ru',},
					],
				},
				rating: null,
				rating2: null,
				datetimelocalvalue: '',
				datevalue: '',
				regularvalue: '',
				tooltipvalue: '',
				popovervalue: '',
				KVKdata:[],
				searchKVK: '',
				objFilters: '[{"objectType":["BUSINESS","COMM_LAND","WAREHOUSE"]}]',
				exportRules: `{"market":{"1":[{"dealType":["SELL"],"objectType":["FLAT","ROOM"]}],"2":[{"dealType":["RENT"],"objectType":["FLAT","HOUSE","ROOM"]}],"3":[{"dealType":["SELL"],"objectType":["HOUSE","LAND"]}],"5":[{"objectType":["COMM_LAND","BUSINESS","WAREHOUSE","GARAGE","PARKING_LOT"]}],"6":[{"dealType":["SELL"],"objectType":["NEWFLAT"]}]},"amount":"price","listingId":"id","id":"id","region":"MapAddress/address/regioncode","addressString":"MapAddress/address/inputText","addressStringFull":"MapAddress/address/inputText","DistrictName":"MapAddress/address/ad5_name","DistrictName_v2":"MapAddress/distr_name","districtId":"","cityId":"","streetId1":"","CityName":"MapAddress/address/ad6_name","StreetName":"MapAddress/address/ad7_name","lat":"MapAddress/coords/0","lng":"MapAddress/coords/1","zSubwayId":"","zSubwayName":"MapAddress/arrMetro/0/metro_name","MetroDistance":"MapAddress/arrMetro/0/distanceToMetro","MetroDistanceType":"MapAddress/arrMetro/0/distanceType","formCity":"distance","fromCity":"distance","vLink":"videoUrl","vDescr":"","title":"name","note":"description","dataInsert":"insertTime","dateUpdate":"updateTime","curator":"agent/code","zObjTypeId":"","zObjTypeName":"","zCurrencyId":"<?php return '1'; ","fileName":"","staffIds":"agent/code","photoTag":"<?php array_map(function($p){return 'https://reactor.anspb.com'.$p;}, $data['photos'] ?? []);","photoCount":"<?php count($data['photos'] ?? []);","regionId":"<?php $bkn_region=[\\n    '01' => 48058, // Республика Адыгея (Адыгея)\\n    '02' => 48060, // Респ Башкортостан\\n    '03' => 48061, // Респ Бурятия\\n    '04' => 48059, // Респ Алтай\\n    '05' => 48062, // Республика Дагестан\\n    '06' => 48063, // Респ Ингушетия\\n    '07' => 48064, // Кабардино-Балкарская Республика\\n    '08' => 48065, // Республика Калмыкия\\n    '09' => 48066, // Карачаево-Черкесская Республика\\n    '10' => 4331, // Республика Карелия\\n    '11' => 46238, // Республика Коми\\n    '12' => 48067, // Республика Марий Эл\\n    '13' => 48068, // Республика Мордовия\\n    '14' => 48069, // Республика Саха (Якутия)\\n    '15' => 48070, // Республика Северная Осетия - Алания\\n    '16' => 48071, // Республика Татарстан (Татарстан)\\n    '17' => 48072, // Республика Тыва\\n    '18' => 48073, // Удмуртская Республика\\n    '19' => 48074, // Республика Хакасия\\n    '20' => 48075, // Чеченская Республика\\n    '21' => 48076, // Чувашия Чувашская республика - Чувашия\\n    '22' => 48077, // Алтайский край\\n    '23' => 17500, // Краснодарский край\\n    '24' => 28200, // Красноярский край\\n    '25' => 48081, // Приморский край\\n    '26' => 26926, // Ставропольский край\\n    '27' => 48082, // Хабаровский край\\n    '28' => 48083, // Амурская область\\n    '29' => 46967, // Архангельская область\\n    '30' => 27600, // Астраханская область\\n    '31' => 48084, // Белгородская область\\n    '32' => 48085, // Брянская область\\n    '33' => 47094, // Владимирская область\\n    '34' => 46253, // Волгоградская область\\n    '35' => 26500, // обл Вологодская\\n    '36' => 42202, // Воронежская область\\n    '37' => 27475, // обл Ивановская\\n    '38' => 48086, // Иркутская область\\n    '39' => 17801, // Калининградская область\\n    '40' => 41923, // Калужская область\\n    '41' => 48079, // Камчатский край\\n    '42' => 48087, // Кемеровская область - Кузбасс\\n    '43' => 48088, // Кировская область\\n    '44' => 46829, // Костромская область\\n    '45' => 48089, // Курганская область\\n    '46' => 48090, // Курская область\\n    '47' => 5001, // Ленинградская область\\n    '48' => 48091, // Липецкая область\\n    '49' => 48092, // Магаданская область\\n    '50' => 17600, // Московская область\\n    '51' => 27700, // Мурманская область\\n    '52' => 27800, // Нижегородская область\\n    '53' => 4332, // Новгородская область\\n    '54' => 48093, // Новосибирская область\\n    '55' => 48094, // Омская область\\n    '56' => 48095, // Оренбургская область\\n    '57' => 48096, // р-н Орловский\\n    '58' => 26600, // Пензенская область\\n    '59' => 48080, // Пермский край\\n    '60' => 16417, // Псковская область\\n    '61' => 41961, // Ростовская область\\n    '62' => 48097, // р-н Рязанский\\n    '63' => 48098, // Самарская область\\n    '64' => 48099, // Саратовская область\\n    '65' => 48100, // Сахалинская область\\n    '66' => 47404, // Свердловская область\\n    '67' => 46133, // Смоленская область\\n    '68' => 48101, // Тамбовская область\\n    '69' => 26700, // Тверская область\\n    '70' => 48102, // Томская область\\n    '71' => 40000, // Тульская область\\n    '72' => 48103, // Тюменская область\\n    '73' => 48104, // Ульяновская область\\n    '74' => 48105, // Челябинская область\\n    '75' => 48078, // Забайкальский край\\n    '76' => 40113, // Ярославская область\\n    '77' => 4000, // г Город Москва\\n    '78' => 1, // г Санкт-Петербург\\n    \\n    '83' => 59154, // Ненецкий автономный округ\\n    '86' => 48107, // Ханты-Мансийский автономный округ - Югра\\n    '87' => 48108, // Чукотский автономный округ\\n    '89' => 48109, // Ямало-Ненецкий автономный округ\\n    '91' => 40122, // Респ Крым\\n    '92' => 40196, // Севастополь\\n    \\n   ];\\n$reg = str_pad($data['MapAddress']['address']['regioncode']??0, 2, '0', STR_PAD_LEFT);\\n$this->bkn_region[$reg] ?? null;"}`,
				fullscreenLoading: false,
			}
		},

		computed:{
			// exportRulesFix(){
			// 	return this.exportRules.replace(/\\n/g,'\\\\n')
			// }
			// tomorrow() {
			// 	// return time.getTime() < Date.now();
			// 	var today = new Date();
			// 	let tomorrow;
			// 	tomorrow = today.setDate(today.getDate()+1);
			// 	console.log(new Intl.DateTimeFormat('en-US',{ year: "numeric", month: "numeric", day: "numeric", hour: "numeric", numeric:"numeric", second:"numeric", hourCycle: "h24" }).format(tomorrow));
			// 	// console.log(new Intl.DateTimeFormat('ru-RU').format(tomorrow));
			// 	console.log(tomorrow);
			// 	return tomorrow;
			// },
		},
		methods: {
			sendBlank(){
				this.$GVO.ApiCall('blanks.INS',{'iData':{
					'staffId':11955,
					'structureId':'2E944C9B-B1F4-11E4-AF2E-080027B197A1',
					'autorId':2601,
					'clientId':7499,
					'blank_type':'Договор',
					'blank_service_type':'вид услуги',
					'blank_service':'услуга',
				}})
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.ApiData = objApi.data;
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			},
			GetCat(){
				this.$GVO.ApiCall('GET',{obj:'cat',flt:{cat_name:this.strCatName}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.masCat = objApi.data;
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			},
			OnUploadFile(objUpload){
				//console.log(objUpload);
				if(typeof objUpload == 'string' && objUpload == '')this.wm_img_src=[];
				if(objUpload == null) return false;
				if(typeof objUpload.selfObj != 'undefined'){
					if(!this.$GVO.isEmpty(objUpload.selfObj.uploadApi)){
						this.bUploading=true;
						this.$GVO.UploadFile(objUpload.formId, objUpload.selfObj.uploadApi.apiMethod, objUpload.selfObj.uploadApi.apiParam)
							.then(objApi => {
								//console.log(objApi);
								if(objApi.success){
									this.wm_img_src=[];
									this.wm_img_src.push(objApi.data.fullpath);
									//вот тут надо обновить или добавить файл вотермарки в таблицу настроек вотермарки
									this.Save();
								}else{
									//console.log(objApi.msg);
									this.$GVO.showAlert('Загрузка файлов',objApi.msg);
								}
								//this.ApplyWatermark();
								this.bUploading=false;
							})
							.catch(errorObjApi => 	{  console.error(errorObjApi); this.bUploading=false;});
					}
				}
			},
			UploadFile(files){
				this.$GVO.UploadFile('uploadForm','UploadTaskHelp',{obj:'FileUpload',flt:{BP_ID:'1',id:'1'}})
					.then(objApi => {  
						//console.log(objApi);
						if(objApi.success){
							// console.log(objApi.data);
						}
					})
					.catch(errorObjApi => 	{  console.error(errorObjApi); });
			},
			getApiData(){
				this.$GVO.ApiCall('GET',{obj:'template'})
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.ApiData = objApi.data;
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			},
			currentFormConfig(){
				return require('src/conf/template_formConfig.js').super_config;
				/*
				this.$GVO.ApiCall('GET_FORM_CONTACT',{obj:'staff',flt:{code:this.$route.params.code}})
					.then((objApi) => {
						//console.log(objApi);
						if(objApi.success){
							this.masAllFormParamsContacts = objApi.config;
						}
					})
					.catch(errorObjApi => console.log(errorObjApi));
				*/
				return [];
			},
			SuccessGo(evt){
				this.$router.push({path: this.$GVO.str_replace('/edit','',evt)});
			},
			updatePolygon(){
				this.$refs.cellEditor.saveData();
			},
			getKVKdata(searchKVK){
				this.KVKdata = [];
				let filter = {};
				if(searchKVK && searchKVK!=''){
					filter = {phone: searchKVK.replace(/[- )(]/g,'')}
				}
				//SGVO.ApiCall("GET",{"obj":"telegram","flt":{phone:'+79812530880'}})
				this.$GVO.ApiCall('GET',{obj:'telegram',flt:{...filter}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.KVKdata = objApi.data;
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
		watch:{
			polygon(val){
				//console.log('update Polygon',val);
			}
		},
		mounted() {
			this.getApiData();
			
		}
	};
</script>
<style>

.Instrfortasks .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0;}

.el-table--enable-row-transition .el-table__body td {
	background-color: transparent;
}
/**/


</style>
